import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PickupsService } from '../service/pickups/pickups.service';
import { SnackBarService } from 'src/app/shared/snack-bar/services/snack-bar.service';
import { basicSnackBarConfig } from 'src/app/utils/default-configs/configuration';

@Component({
  selector: 'app-cancel-pickup',
  templateUrl: './cancel-pickup.component.html',
  styleUrls: ['./cancel-pickup.component.css'],
})
export class CancelPickupComponent implements OnInit {
  pickupCancelForm: FormGroup;
  confirmationNumber: string;
  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    private pickupsService: PickupsService,
    private dialogRef: MatDialogRef<any>,
    private snackBarService: SnackBarService,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    if (data != null) {
      this.confirmationNumber = data.rowData.confirmationNumber;
    }
  }

  ngOnInit(): void {
    this.intialisePickupCancelFormGroup();
    this.pickupCancelForm.get('pickup_id').patchValue(this.confirmationNumber);
  }

  intialisePickupCancelFormGroup() {
    this.pickupCancelForm = this.fb.group({
      requestorName: new FormControl('', Validators.required),
      pickup_id: new FormControl('', Validators.required),
      reason: new FormControl('', Validators.required),
    });
  }

  cancelPickup() {
    const reqBody = {
      body: this.pickupCancelForm.value,
    };
    this.pickupsService.cancelPickup(reqBody).subscribe({
      next: () => {
        this.dialogRef.close(true);
        this.snackBarService.createSnackBar(
          basicSnackBarConfig.pickupCancel?.message,
          basicSnackBarConfig.pickupCancel?.horizontalPosition,
          basicSnackBarConfig.pickupCancel?.verticalPosition,
          basicSnackBarConfig.pickupCancel?.duration
        );
      },
    });
  }

  closeDialog() {
    this.dialog.closeAll();
  }
}
